<template>
  <div class="homePage">
    <div class="message flex-rowl">
      <div class="icon"><i class="iconfont icon-iconxx1"></i></div>
      <div class="txt">收到了新的业务消息</div>
    </div>
    <div class="card_list" v-if="dept.role">
      <!-- <div
        class="card_item flex-rowl"
        @click="handelShowPopup(1)"
        v-if="dept.role == 1"
      >
        <i class="iconfont icon-iconfontscan"></i> 扫码接单
      </div>  -->
      <div
        class="card_item flex-rowl"
        @click="handelShowPopup(2)"
        v-if="dept.role == 2 || dept.role == 1"
      >
        <i class="iconfont icon-iconfontscan"></i> 扫码取餐
      </div> 
      <!-- <div
        class="card_item flex-rowl"
        @click="handelShowPopup(3)"
        v-if="dept.role == 3 || dept.role == 1"
      >
        <i class="iconfont icon-iconfontscan"></i> 扫码送餐
      </div> -->
      <div
        class="card_item flex-rowl"
        @click="handelShowPopup(4)"
        v-if="dept.role == 4 || dept.role == 1"
      >
        <i class="iconfont icon-iconfontscan"></i> 扫码送达处理
      </div>

      <div class="card_item flex-rowl" @click="handleDispatch(1)" v-if="dept.role == 1 && dept.ispao == 1">
        <i class="iconfont icon-iconfontscan"></i> 跑腿业务员订单管理
      </div>
      <div class="card_item flex-rowl" @click="handleDispatch(2)" v-if="dept.role == 1">
        <i class="iconfont icon-iconfontscan"></i> 跑腿服务
      </div>

      <!-- <div
        class="card_item flex-rowl"
        @click="handleToast"
        v-if="dept.role == 4 || dept.role == 1"
      >
        <i class="iconfont icon-iconfontscan"></i> 故障上报
      </div> -->
      <!-- <div class="card_item flex-rowl" @click="handleGO()">
        <i class="iconfont icon-iconfontscan"></i> 扫码测试
      </div> -->
    </div>

    <!-- 选择类型弹窗 start -->
    <van-popup v-model="isShowPopup">
      <div class="popup_container">
        <div class="popup_wrap">
          <div class="btn_item flex-between" @click="handleScance">
            <p>扫码获取</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
          <div class="btn_item flex-between" @click="handleShowTextarea" v-if="type != 2 && type != 4">
            <p>手动输入订单号</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
          <!-- v-if="type == 4" -->
          <div
            class="btn_item flex-between"
            @click="handleShowTel"
            
          >
            <p>点餐用户手机号查询</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
        </div>
        <div class="close" @click="isShowPopup = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </van-popup>
    <!-- 选择类型弹窗 end -->

    <!-- 输入框弹窗 start -->
    <van-popup v-model="isShowPopupTextarea">
      <div class="popup_container">
        <div class="popup_wrap">
          <div class="textarea_box">
            <van-field
              type="textarea"
              v-model="orderNo"
              placeholder="输入订单号"
            />
          </div>
          <div class="custom_btn" @click="handleQuery(false)">
            确认 <i class="iconfont icon-yuyinjiantou"></i>
          </div>
        </div>
        <div class="close" @click="isShowPopupTextarea = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </van-popup>
    <!-- 输入框弹窗 end -->

    <!-- 输入框弹窗 start -->
    <van-popup v-model="isShowPopupTel">
      <div class="popup_container">
        <div class="popup_wrap">
          <div class="textarea_box">
            <van-field
              type="number"
              v-model="phoneend"
              placeholder="下单用户手机号末四位"
            />
          </div>
          <div class="custom_btn" @click="handleQueryTel">
            确认 <i class="iconfont icon-yuyinjiantou"></i>
          </div>
        </div>
        <div class="close" @click="isShowPopupTel = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </van-popup>
    <!-- 输入框弹窗 end -->
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "home",
  data() {
    return {
      // role 职能身份  "1","综合服务人员"|"2","取餐员"|"3","送餐员"|"4","点位服务人员"|"5","派单管理员" ｜"6",跑腿业务派单管理员
      isShowPopup: false,
      isShowPopupTextarea: false,
      isShowPopupTel: false,
      isShow: false,
      dept: "",
      userInfo: "",

      type: 1, // 触发类型
      orderNo: "", // 订单号
      phoneend: "", // 手机号四位
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.dept.length > 0) {
      this.dept = userInfo.dept[0];
    }
  },
  methods: {
    // 显示弹窗
    handelShowPopup(type) {
      this.type = type;
      this.isShowPopup = true;
    },

    // 根据订单号查询
    handleQuery(isGo) {
      let { orderNo, type } = this;
      if (isGo) {
        this.$router.push(`/parkFlash/pOrderList`);
      } else {
        if (orderNo == "") {
          this.$toast("请输入订单号");
          return;
        }
        if (type == 1) {
          this.$router.push(`/tekeOrder/tOrderIndex/${orderNo}`);
        } else if (type == 2) {
          this.$router.push(`/tekeMeal/tMealIndex/${orderNo}/${true}`);
        } else if (type == 3) {
          this.$router.push(`/sendMeal/sMealIndex/${orderNo}`);
        } else if (type == 4) {
          this.$router.push(`/dispatch/dIndex/${orderNo}`);
        }
      }
    },

    // 跑腿服务
    handleDispatch(type) {
      if(type == 1) {
        this.$router.push(`/parkFlash/pList`);
      }else {
         this.$router.push(`/parkFlash/pOrderList`);
      }
    },

    // 通过手机号查询
    handleQueryTel() {
      let { phoneend, type } = this;
      if (phoneend == "") {
        Toast("请输入手机号后四位");
        return;
      }
      let newType = type == 4 ? 3 : type
      // let newType = type == 4 ? 3 : type
      this.$router.push(`/tekeOrder/tOrderList/${phoneend}/${newType}`);
    },
    // 扫码
    handleScance() {
      console.log(this.type,'===-===this.type');
      this.$router.push(`/qrcode/${this.type}`);
    },

    handleToast() {
      this.$toast("即将开放");
      return;
    },

    handleShowTextarea() {
      this.isShowPopup = false;
      this.isShowPopupTextarea = true;
    },
    handleShowTel() {
      this.isShowPopup = false;
      this.isShowPopupTel = true;
    },
  },
};
</script>
<style lang='less' scoped>
.homePage {
  .message {
    width: 640px;
    margin: 100px auto 80px;
    font-size: 20px;
    color: #1e1e1e;
    .icon-iconxx1 {
      font-size: 46px;
      margin-right: 30px;
    }
    .txt {
      flex: 1;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .card_list {
    .card_item {
      width: 660px;
      height: 130px;
      background: #ffffff;
      box-shadow: 0px 9px 30px 0px rgba(4, 0, 0, 0.09);
      border-radius: 40px;
      font-size: 28px;
      color: #000000;
      margin: auto;
      padding: 0 45px;
      box-sizing: border-box;
      margin-bottom: 30px;
      .icon-iconfontscan {
        color: #ea3329;
        font-size: 40px;
        margin-right: 35px;
      }
    }
  }
  /deep/ .van-popup {
    background: transparent;
  }
  .popup_container {
    position: relative;
    // height: 600px;
    padding-bottom: 100px;
    box-sizing: border-box;
    .popup_wrap {
      width: 660px;
      // height: 500px;
      box-sizing: border-box;
      padding: 30px 0;
      background: #fff;
      .btn_item {
        width: 600px;
        height: 150px;
        border: 1px solid #a0a0a0;
        font-size: 30px;
        padding: 0 60px 0 68px;
        box-sizing: border-box;
        margin: 0 auto 30px;
        &:last-child {
          margin-bottom: 0;
        }
        .icon-youjiantou {
          font-size: 30px;
          color: #515151;
        }
      }
      .textarea_box {
        border-radius: 0;
        margin-bottom: 40px;
        padding: 15px 20px;
        box-sizing: border-box;
        /deep/ .van-cell {
          padding: 0;
          width: 100%;
          height: 100%;
        }
        /deep/ .van-field__body {
          height: 100%;
        }
        /deep/ .van-field__control {
          height: 100%;
        }
      }
      .custom_btn {
        background: #373737;
        position: relative;
        .icon-yuyinjiantou {
          position: absolute;
          transform: rotate(-90deg);
          right: 20px;
        }
      }
    }
    .close {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      .iconfont {
        font-size: 50px;
        color: #fff;
      }
    }
  }
}
</style>